// combatpro/runtime/GeneratedFamilySection.js
//
// Combat PRO - the reusable Random / Wave family block: the generator control card
// plus the 12 generated slot cards (spec 6: the dashboard sections and the dedicated
// pages render this SAME component, so generator logic/state/actions are never
// duplicated). Tier gating mirrors the Standard bank (spec 24: no entitlement change,
// the new banks are bounded the same way). No optional chaining. No em dash.

import React, { useState } from 'react';
import { useEncounterGenerator } from './useEncounterGenerator';
import { familyArrayKey, activeFamilyOf, countSavedEncounters } from '../encounter/encounterStoreEngine';
import EncounterGeneratorCard from './EncounterGeneratorCard';
import GeneratedSlotCard from './GeneratedSlotCard';

function firstEmpty(slots) {
  for (var i = 0; i < slots.length; i++) {
    if (slots[i] && slots[i].gen && slots[i].gen.state === 'empty') { return i; }
  }
  return 0;
}

function GeneratedFamilySection(props) {
  var family = props.family;
  var gen = useEncounterGenerator(family);
  var ctx = gen.ctx;
  var store = ctx.state.encounterStore;
  var slots = (store && Array.isArray(store[familyArrayKey(family)])) ? store[familyArrayKey(family)] : [];
  var activeFam = store ? activeFamilyOf(store) : 'standard';
  var activeIdx = (store && typeof store.activeIndex === 'number') ? store.activeIndex : 0;

  var targetHook = useState(function () { return firstEmpty(slots); });
  var target = targetHook[0];
  var setTarget = targetHook[1];

  function doGenerate(ix) { gen.generate(ix); }

  var ent = ctx.state.entitlement ? ctx.state.entitlement : { perFamily: 2, total: 2, cloud: false };
  var counts = countSavedEncounters(store);
  var famCount = counts[family] || 0;

  return (
    <div className="cp-fam-section">
      <div className="cp-quota-bar">
        <span className="cp-quota-item">{'Saved ' + (family.charAt(0).toUpperCase() + family.slice(1)) + ': '}<b>{famCount + ' / ' + ent.perFamily}</b></span>
        <span className="cp-quota-item">{'Total saved: '}<b>{counts.total + ' / ' + ent.total}</b></span>
        <span className="cp-quota-note">{ent.cloud ? 'Combat PRO Cloud' : 'Lifetime (2 total). Generate/run freely; saving beyond the limit needs Cloud.'}</span>
      </div>
      <EncounterGeneratorCard gen={gen} slots={slots} target={target} setTarget={setTarget} />
      <div className="cp-slot-grid">
        {slots.map(function (slot, i) {
          return (
            <GeneratedSlotCard
              key={i}
              family={family}
              index={i}
              slot={slot}
              isActive={activeFam === family && activeIdx === i}
              ctx={ctx}
              onGenerate={doGenerate}
              onReroll={doGenerate}
            />
          );
        })}
      </div>
    </div>
  );
}

export default GeneratedFamilySection;
